import React from 'react';
import { Truck, CheckCircle2, Clock, AlertTriangle } from 'lucide-react';
import { OperacionalStats } from '../../types/operacional';

interface Props {
  stats: OperacionalStats;
}

export const OperacionalHeaderStats: React.FC<Props> = ({ stats }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {/* Motoristas em Rota */}
      <div className="bg-white p-4 rounded-xl border border-slate-200/80 shadow-sm flex items-center justify-between">
        <div>
          <p className="text-xs font-medium text-slate-500">Motoristas em Rota</p>
          <p className="text-2xl font-bold text-slate-900 mt-0.5">{stats.motoristas_em_rota}</p>
        </div>
        <div className="p-2.5 rounded-xl bg-blue-50 text-blue-600 border border-blue-100">
          <Truck className="h-5 w-5" />
        </div>
      </div>

      {/* Paradas Concluídas */}
      <div className="bg-white p-4 rounded-xl border border-slate-200/80 shadow-sm flex items-center justify-between">
        <div>
          <p className="text-xs font-medium text-slate-500">Paradas Concluídas</p>
          <p className="text-2xl font-bold text-emerald-600 mt-0.5">{stats.paradas_concluidas_hoje}</p>
        </div>
        <div className="p-2.5 rounded-xl bg-emerald-50 text-emerald-600 border border-emerald-100">
          <CheckCircle2 className="h-5 w-5" />
        </div>
      </div>

      {/* Paradas Pendentes */}
      <div className="bg-white p-4 rounded-xl border border-slate-200/80 shadow-sm flex items-center justify-between">
        <div>
          <p className="text-xs font-medium text-slate-500">Paradas Pendentes</p>
          <p className="text-2xl font-bold text-amber-600 mt-0.5">{stats.paradas_pendentes_hoje}</p>
        </div>
        <div className="p-2.5 rounded-xl bg-amber-50 text-amber-600 border border-amber-100">
          <Clock className="h-5 w-5" />
        </div>
      </div>

      {/* Ocorrências */}
      <div className={`bg-white p-4 rounded-xl border shadow-sm flex items-center justify-between ${
        stats.alertas_ocorrencias > 0 ? 'border-red-200 bg-red-50/10' : 'border-slate-200/80'
      }`}>
        <div>
          <p className="text-xs font-medium text-slate-500">Alertas / Ocorrências</p>
          <p className={`text-2xl font-bold mt-0.5 ${stats.alertas_ocorrencias > 0 ? 'text-red-600' : 'text-slate-900'}`}>
            {stats.alertas_ocorrencias}
          </p>
        </div>
        <div className={`p-2.5 rounded-xl border ${
          stats.alertas_ocorrencias > 0 ? 'bg-red-50 text-red-600 border-red-100' : 'bg-slate-50 text-slate-400 border-slate-100'
        }`}>
          <AlertTriangle className="h-5 w-5" />
        </div>
      </div>
    </div>
  );
};
